import { render, staticRenderFns } from "./btn_mails.vue?vue&type=template&id=7eb4d2dc&scoped=true"
import script from "./btn_mails.vue?vue&type=script&lang=js"
export * from "./btn_mails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb4d2dc",
  null
  
)

export default component.exports